import { createColDef } from '@fortem-monorepo/react-ag'

import { WrapperBucketIdCellEditor } from '@/ag-grid/columns/wrapper-bucket-id/cell-editor'
import { WrapperBucketIdCellRenderer } from '@/ag-grid/columns/wrapper-bucket-id/renderer'

export const wrapper_bucket_id = createColDef({
  field: 'wrapper_bucket_id',
  headerName: 'Wrapper Bucket',
  cellRenderer: WrapperBucketIdCellRenderer,
  cellEditor: WrapperBucketIdCellEditor,
  width: 100,
})
